import { Button, Divider, Table } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ContentPanel from "../shared/ContentPanel";
import { accountProviderColumns, accountUsersColumns } from "./AccountConfig";
import AccountService from "./AccountService";
import './style.scss';

const useAccount = ({ searchId }) => {

    const [account, setAccount] = useState()

    const fetchAccountDetail = async (searchId) => {
        const account = await AccountService.getAccount({ searchId })
        if (!account) throw Error("account not found")
        setAccount(account);
    }

    return { account, fetchAccountDetail }
}

const UserAccount = ({ }, _, fetchAllEntities) => {
    const { searchId } = useParams();
    const { account, fetchAccountDetail } = useAccount({ searchId });

    useEffect(() => { fetchAccountDetail(searchId) }, [searchId])

    const onDeleteAccount = async () => {
        await AccountService.deleteAccounts({ 0: account })
        if (fetchAllEntities && typeof fetchAllEntities === "function")
            await fetchAllEntities();
    }

    return (
        <section>
            {!fetchAllEntities && <div className="page-account-details">
                <div className="page-account-info">
                    <Divider orientation="left">Account Info</Divider>
                    <div><b>Account name: </b><p>{account?.name}</p></div>
                    <div><b>Account Id: </b><p>{account?.accountId}</p></div>
                    <div><b>Currency: </b><p>{account?.currency}</p></div>
                    <div><b>Last Login: </b><p>{moment(account?.lastLogin).format('M/D/YYYY @ H:M:SS A')}</p></div>
                </div>
                <div className="page-account-metadata">
                    <Divider orientation="left">Account Metadata</Divider>
                    <div><b>aovGoal: </b><p>{account?.metadata?.goals?.aovGoal}</p></div>
                    <div><b>cppGoal: </b><p>{account?.metadata?.goals?.cppGoal}</p></div>
                    <div><b>merGoal: </b><p>{account?.metadata?.goals?.merGoal}</p></div>
                    <div><b>ovGoal: </b><p>{account?.metadata?.goals?.ovGoal}</p></div>
                    <div><b>revenueGoal: </b><p>{account?.metadata?.goals?.revenueGoal}</p></div>
                </div>
                <div className="page-account-tracking">
                    <Divider orientation="left">Account Tracking</Divider>
                    <div><b>Account: </b><p>{account?.tracking?.account}</p></div>
                    <div><b>trackingId: </b><p>{account?.tracking?.trackingId}</p></div>
                    <div><b>Configure Domains: </b><p>{account?.tracking?.config?.domains}</p></div>
                    <div><b>Configure Enabled: </b><p>{account?.tracking?.config?.enabled.toString()}</p></div>
                    <div><b>Date Created: </b><p>{account?.tracking?.dateCreated}</p></div>
                </div>
            </div>}
            <ContentPanel dividerOrientation="left" title="Account Users">
                <Table columns={accountUsersColumns} dataSource={account?.accountUsers} />
            </ContentPanel>
            <ContentPanel dividerOrientation="left" title="Account Providers">
                <Table columns={accountProviderColumns} dataSource={account?.providers} />
            </ContentPanel>
            <div>
                <Button type="danger" onClick={onDeleteAccount}>Delete Account</Button>
            </div>
        </section>
    )
}

export default UserAccount;